export interface ILocationState {
    from: { pathname: string }
}

export enum IRoleEnum {
    'ADMIN' = 0,
    'USER' = 1,
}
